const { get } = require('lodash');

module.exports = function(value) {
  // Table
  if (get(value, 'value.time')) {
    return get(value, 'value.time');
  }
  // Section
  if (get(value, 'value')) {
    return get(value, 'value');
  }
  return '';
};
